"use strict";
/**
 * 资金流图
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title1MiniZJLChart = exports.MinZJLSvgChart = exports.MinZJLChart = void 0;
var react_1 = __importStar(require("react"));
var title_1 = require("../title");
var zjl_1 = require("../../../../modules/quote/zjl");
require("./style.less");
var swr_1 = __importDefault(require("swr"));
/**
 * 资金流chart
 * @param props
 * @returns
 */
function MinZJLChart(props) {
    var _a, _b, _c;
    // const id = "quotechart" + Math.floor(Math.random() * 1000000 + 1)
    var thischart = (0, react_1.useRef)(null);
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : 240;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 180;
    var timeout = (_c = props.timeout) !== null && _c !== void 0 ? _c : 60;
    var draw = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data, axis, option;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!window.emcharts3)
                            return [2 /*return*/];
                        return [4 /*yield*/, (0, zjl_1.getZJL)(props.bkcode)];
                    case 1:
                        data = _b.sent();
                        axis = formatData(data) || {
                            xaxis: [],
                            ydata: []
                        };
                        option = {
                            container: "#zjl_chart",
                            width: width,
                            height: height,
                            title: "".concat(data === null || data === void 0 ? void 0 : data.name, "\u8D44\u91D1\u6D41"),
                            subfix: '万元',
                            xaxis: axis.xaxis,
                            yaxis: {
                                title: '资金净流入',
                                data: axis.ydata
                            },
                            bigImg: {
                                stauts: 'show'
                            },
                        };
                        if (thischart.current == null) {
                            thischart.current = new window.emcharts3.fundmini(option);
                        }
                        thischart.current.setData(option);
                        if (((_a = axis.xaxis) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            thischart.current.draw();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        if (window.emcharts3) {
            var cd_1;
            if (timeout > 0) {
                cd_1 = setInterval(function () {
                    draw();
                }, timeout * 1000);
            }
            draw();
            return function () {
                clearInterval(cd_1);
            };
        }
    }, [props.bkcode]);
    return (react_1.default.createElement("div", { className: "minizjlchart" },
        react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/".concat(props.bkcode.split('.')[1], ".html") },
            react_1.default.createElement("div", { id: "zjl_chart" }))));
}
exports.MinZJLChart = MinZJLChart;
/**
 * svg版资金流图
 * @param props
 * @returns
 */
function MinZJLSvgChart(props) {
    var _a, _b, _c;
    var _d = (0, swr_1.default)("fflow/kline_".concat(props.bkcode), function () { return (0, zjl_1.getZJL)(props.bkcode); }, {
        refreshInterval: 10 * 60 * 1000,
        // dedupingInterval: 9.9 * 60 * 1000
    }), data = _d.data, error = _d.error;
    var width = (_a = props.width) !== null && _a !== void 0 ? _a : 240;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 180;
    var timeout = (_c = props.timeout) !== null && _c !== void 0 ? _c : 60;
    var draw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var axis, option, chart;
            return __generator(this, function (_a) {
                if (!window.svgcharts2023 || data == null)
                    return [2 /*return*/];
                axis = formatData(data) || {
                    xaxis: [],
                    ydata: []
                };
                option = {
                    container: document.getElementById("zjl_chart"),
                    width: width,
                    height: height,
                    title: "".concat(data === null || data === void 0 ? void 0 : data.name, "\u8D44\u91D1\u6D41"),
                    subfix: '万元',
                    xaxis: {
                        trendsTotal: 241,
                        data: axis.xaxis
                    },
                    yaxis: {
                        pointnum: 5,
                        subfix: '万元',
                        title: '资金净流入',
                        data: axis.ydata
                    },
                    padding: {
                        t: 0,
                        b: 0,
                        l: 0,
                        r: 0
                    },
                    showBgImg: true,
                    interaction: true
                };
                chart = new window.svgcharts2023.ZJLline(option);
                chart.draw();
                return [2 /*return*/];
            });
        });
    };
    (0, react_1.useEffect)(function () {
        if (window.svgcharts2023) {
            var cd_2;
            if (timeout > 0) {
                cd_2 = setInterval(function () {
                    draw();
                }, timeout * 1000);
            }
            draw();
            return function () {
                clearInterval(cd_2);
            };
        }
    }, [data]);
    return (react_1.default.createElement("div", { className: "minizjlchart" },
        react_1.default.createElement("a", { href: "//data.eastmoney.com/bkzj/".concat(props.bkcode.split('.')[1], ".html") },
            react_1.default.createElement("div", { id: "zjl_chart" }))));
}
exports.MinZJLSvgChart = MinZJLSvgChart;
/** 带Title的资金流图 */
function Title1MiniZJLChart(props) {
    var code = props.bkcode.split('.')[1];
    return (react_1.default.createElement("div", { className: "titleminitc" },
        react_1.default.createElement(title_1.Title1, null,
            react_1.default.createElement(title_1.Title1.Main, null, props.link ?
                react_1.default.createElement("a", { href: "https://data.eastmoney.com/bkzj/".concat(code, ".html") }, props.children)
                :
                    react_1.default.createElement(react_1.default.Fragment, null, props.children)),
            props.more && react_1.default.createElement(title_1.Title1.More, null,
                react_1.default.createElement(react_1.default.Fragment, null, props.more))),
        react_1.default.createElement("div", { className: props.border !== false ? 'titleminitcb' : '' },
            react_1.default.createElement("div", { style: { marginTop: 10 } },
                react_1.default.createElement(MinZJLSvgChart, __assign({}, props, { key: props.bkcode }))))));
}
exports.Title1MiniZJLChart = Title1MiniZJLChart;
/**
 * 资金流坐标数据
 * @param json
 * @returns
 */
function formatData(json) {
    var _a, _b;
    if (!((json === null || json === void 0 ? void 0 : json.klines) && ((_a = json === null || json === void 0 ? void 0 : json.klines) === null || _a === void 0 ? void 0 : _a.length))) {
        return false;
    }
    var showtime = ['09:30', '11:30/13:00', '15:00'];
    var Periods = getPeriods((_b = json === null || json === void 0 ? void 0 : json.tradePeriods) === null || _b === void 0 ? void 0 : _b.periods);
    var xaxis = [], ydata = [];
    var data = (json === null || json === void 0 ? void 0 : json.klines) || [];
    for (var i = 0; i < Periods.length; i++) {
        var time = Periods[i];
        var item = data[i];
        if (item) {
            var arr = item.split(",");
            // 处理纵坐标
            ydata.push((Number(arr[1]) / 1e4).toFixed(2));
        }
        // 处理横坐标
        if (time === "11:30") {
            time = "11:30/13:00";
        }
        ;
        if (time) {
            xaxis.push({
                show: showtime.indexOf(time) >= 0,
                showline: showtime.indexOf(time) >= 0,
                time: time
            });
        }
    }
    var start = xaxis[0], end = xaxis[xaxis.length - 1];
    if (start) {
        start.show = true;
        start.showline = true;
    }
    if (end) {
        end.show = true;
        end.showline = true;
    }
    return {
        xaxis: xaxis,
        ydata: ydata
    };
}
/**
 * 获取横坐标
 * @param {Array<sting>} periods
 */
function getPeriods(periods) {
    if (!periods || !periods.length)
        return [];
    var ret = [];
    for (var i = 0; i < periods.length; i++) {
        var item = periods[i];
        for (var t = item.b + 1; t <= item.e; t++) {
            if (t % 100 >= 60) {
                continue;
            }
            var date_str = t.toString();
            ret.push(date_str.substring(8, 10) + ':' + date_str.substring(10));
        }
    }
    return ret;
}
